import { createPollingInterval } from "@sg-protect/core";
import type { MethodResponse } from "openapi-fetch";
import { type client, queryOptions } from "../client.ts";
import {
    type InitializingCategoryKey,
    InitializingCategoryKeys,
    MigrateExcludedCategories
} from "../crawlCategories.ts";
import type { TenantCrawlOverviewDto } from "../types.ts";

export type InitialCrawlOverviewResponse = MethodResponse<typeof client, "get", "/bff/initial-crawl-overview">;

function isTenantInitializing(
    tenant: TenantCrawlOverviewDto,
    excludedKeys: readonly InitializingCategoryKey[] = []
): boolean {
    return InitializingCategoryKeys.some(key => !excludedKeys.includes(key) && tenant[key]);
}

function isCrawlingFinished(data: InitialCrawlOverviewResponse | undefined): boolean {
    if (!data) {
        return false;
    }

    const isPrimaryFinished = !data.primary || !isTenantInitializing(data.primary);
    const areMigrateAssessmentsFinished = data.migrateAssessments.every(
        tenant => !isTenantInitializing(tenant, MigrateExcludedCategories)
    );

    return isPrimaryFinished && areMigrateAssessmentsFinished;
}

const initialCrawlOverviewRefetchInterval = createPollingInterval<InitialCrawlOverviewResponse>({
    isPending: data => !isCrawlingFinished(data),
    interval: 10000,
    timeout: Infinity
});

export function initialCrawlOverviewQueryOptions() {
    return queryOptions("get", "/bff/initial-crawl-overview", undefined, {
        refetchInterval: initialCrawlOverviewRefetchInterval
    });
}
